import React, { useState, useEffect } from 'react';
import { decryptData } from '../../../utils/encrypt';
import {
  SALES_ORDER_HEADER_UPDATE,
  SALES_ORDER_ATTACHMENT_UPDATE,
  SALES_ORDER_ITEM_UPDATE, SALES_ORDER_ATTACHEMENT_DELETE, SALES_ORDER_EXISTING_PLANS,
  SO_CREATE_WABA_ENDPOINT, SO_UPDATE_WABA_ENDPOINT,  SALES_ORDER_ATTACHMENT_DOWNLOAD
} from '../../../config/api';

import PlanningHistoryCard from '../../soplanning/cards/PlanningHistoryCard';
import PlanningBalanceCard from '../../soplanning/cards/PlanningBalanceCard';

function SalesOrderCard({ order, setOrder }) {
  const [showHeaderEdit, setShowHeaderEdit] = useState(false);
  const [showAttachmentEdit, setShowAttachmentEdit] = useState(false);
  const [showItemEdit, setShowItemEdit] = useState(false);

  const [editModal, setEditModal] = useState({
    show: false,
    item: null,
    index: null,
    qty: '',
    price: ''
  });



  const [planningHistory, setPlanningHistory] = useState([]);

  const [header, setHeader] = useState({
    customer_po_no: order.customer_po_no,
    po_date: order.po_date,
    remark: order.remark
  });

  const [items, setItems] = useState([]);

  useEffect(() => {
    if (Array.isArray(order.items)) {
      const mappedItems = order.items.map(item => ({
        id: item.id,
        material_id: item.material_id,
        material_name: item.material_name,
        unit: item.unit,
        qty: parseFloat(item.qty || 0),
        price: parseFloat(item.price || 0),
        gst: parseFloat(item.gst || 0)
      }));
      setItems(mappedItems);
    }
  }, [order.items]);

  useEffect(() => {
    if (!order?.id) return;
    fetch(SALES_ORDER_EXISTING_PLANS, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sales_order_id: order.id })
    })
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          setPlanningHistory(data);
        }
      })
      .catch(err => {
        console.error('Planning history fetch error:', err);
      });
  }, [order?.id]);

  const [attachments, setAttachments] = useState(order.attachments || []);



  const handleAttachmentChange = (e) => {
    const newFiles = Array.from(e.target.files);
    setAttachments([...attachments, ...newFiles]);
  };

  const removeAttachment = (index) => {
    const updated = [...attachments];
    updated.splice(index, 1);
    setAttachments(updated);
  };



  const handleDeleteExistingAttachment = async (attachmentId) => {
    if (!window.confirm("Are you sure you want to delete this attachment?")) return;

    try {
      const res = await fetch(SALES_ORDER_ATTACHEMENT_DELETE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attachment_id: attachmentId })
      });

      const result = await res.json();

      if (res.ok && result.success) {
        setOrder(prev => ({
          ...prev,
          attachments: prev.attachments.filter(att => att.id !== attachmentId)
        }));
        alert('Attachment deleted');
      } else {
        alert(result.error || 'Failed to delete attachment');
      }
    } catch (err) {
      console.error('Delete error:', err);
      alert('Server error');
    }
  };


  const handleHeaderSave = async () => {
    try {
      const encrypted = localStorage.getItem('suyog_user');
      const parsed = decryptData(encrypted);

      const res = await fetch(SALES_ORDER_HEADER_UPDATE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          order_id: order.id,
          user_id: parsed.user_id,
          customer_po_no: header.customer_po_no,
          po_date: header.po_date,
          remark: header.remark
        })
      });

      const result = await res.json(); // ✅ safer

      if (res.ok && result.success && result.data) {
        setOrder(prev => ({
          ...prev,
          ...result.data
        }));
        setShowHeaderEdit(false);
        alert('Header updated');
      } else {
        console.error("Server error details:", result);
        alert(result.error || 'Failed to update header');
      }
    } catch (err) {
      console.error('Fetch error:', err);
      alert('Server error');
    }
  };

  const handleAttachmentSave = async () => {
    try {
      const encrypted = localStorage.getItem('suyog_user');
      const parsed = decryptData(encrypted);

      const formData = new FormData();
      formData.append('order_id', order.id);
      formData.append('user_id', parsed.user_id);

      const newFiles = attachments.filter(file => file instanceof File);

      if (newFiles.length === 0) {
        alert('Please select files to upload.');
        return;
      }

      newFiles.forEach(file => {
        formData.append('files[]', file);
      });

      const res = await fetch(SALES_ORDER_ATTACHMENT_UPDATE, {
        method: 'POST',
        body: formData
      });

      const result = await res.json();

      if (res.ok && result.success) {
        setShowAttachmentEdit(false);
        setAttachments([]); // Clear uploaded files
        setOrder(prev => ({
          ...prev,
          attachments: [...(prev.attachments || []), ...result.data]
        }));
        alert('Attachments updated'); // ✅ success only after insertion
      } else {
        console.error('Upload failed:', result);
        alert(result.error || 'Failed to update attachments');
      }
    } catch (err) {
      console.error('Attachment upload error:', err);
      alert('Server error');
    }
  };


  // ✅ Fetch Planning History
  useEffect(() => {
    if (!order?.id) return;
    fetch(SALES_ORDER_EXISTING_PLANS, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sales_order_id: order.id })
    })
      .then(res => res.json())
      .then(data => {
        if (Array.isArray(data)) {
          setPlanningHistory(data);
        }
      })
      .catch(err => {
        console.error('Planning history fetch error:', err);
      });
  }, [order?.id]);


  useEffect(() => {
    if (Array.isArray(order.items)) {
      const mappedItems = order.items.map(item => ({
        id: item.id,  // 🔥 must be there for update
        material_id: item.material_id,
        material_name: item.material_name,
        unit: item.unit,
        qty: parseFloat(item.qty),
        price: parseFloat(item.price),
        gst: parseFloat(item.gst || 0)
      }));
      setItems(mappedItems);
    }
  }, [order.items]);


  const handleItemSave = async () => {
    try {
      const encrypted = localStorage.getItem('suyog_user');
      const parsed = decryptData(encrypted);
      const userId = parsed?.user_id;

      if (!userId || !order?.id) {
        alert("Missing user or order ID");
        return;
      }

      console.log("🔍 Raw items before filtering:", items);

      const cleanItems = items
        .filter(item =>
          item.id &&
          !isNaN(item.qty) &&
          !isNaN(item.price)
        )
        .map(item => ({
          id: item.id,
          qty: parseFloat(item.qty),
          price: parseFloat(item.price),
          gst: parseFloat(item.gst || 0)
        }));

      if (cleanItems.length === 0) {
        console.warn("⚠️ No valid items found for update.");
        console.table(items); // Show full input
        alert("No valid items to update");
        return;
      }

      console.log("✅ Clean items to send:", cleanItems);

      const res = await fetch(SALES_ORDER_ITEM_UPDATE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          order_id: order.id,
          user_id: userId,
          items: cleanItems
        })
      });

      const result = await res.json();
      console.log("Server response:", result);

      if (res.ok && result.success) {
        alert('Items updated successfully');
        setShowItemEdit(false);
        setOrder(prev => ({ ...prev, items: result.data }));
      } else {
        alert(result.error || 'Failed to update items');
      }
    } catch (err) {
      console.error('Item update error:', err);
      alert('Server error');
    }
  };


  const handleItemModalSave = async () => {
    try {
      const encrypted = localStorage.getItem('suyog_user');
      const parsed = decryptData(encrypted);
      const userId = parsed?.user_id;

      const updatedItem = {
        id: editModal.item.id,
        qty: parseFloat(editModal.qty),
        price: parseFloat(editModal.price),
        gst: parseFloat(editModal.item.gst || 0)
      };

      const res = await fetch(SALES_ORDER_ITEM_UPDATE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          order_id: order.id,
          user_id: userId,
          ...updatedItem  // ✅ Send directly as keys
        })
      });

      const result = await res.json();
      console.log('✅ Server response:', result);

      if (res.ok && result.success) {
        const updatedItems = [...items];
        updatedItems[editModal.index] = {
          ...updatedItems[editModal.index],
          qty: updatedItem.qty,
          price: updatedItem.price
        };
        setItems(updatedItems);
        setOrder(prev => ({ ...prev, items: result.data }));
        setEditModal({ show: false, item: null, index: null, qty: '', price: '' });
        alert('Item updated successfully');
      } else {
        alert(result.error || 'Failed to update item');
      }
    } catch (err) {
      console.error('Item update error:', err);
      alert('Server error');
    }
  };
const sendWabaNotification = async (salesOrderId, customerId, type = 'created') => {
  if (!salesOrderId || !customerId) {
    alert("Missing Sales Order ID or Customer ID");
    return;
  }

  const url =
    type === 'created'
      ? SO_CREATE_WABA_ENDPOINT
      : SO_UPDATE_WABA_ENDPOINT;

  try {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ sales_order_id: salesOrderId, customer_id: customerId })
    });

    const result = await res.json();
    if (res.ok && result.success) {
      alert('✅ WhatsApp message sent successfully');
    } else {
      console.error(result);
      alert(result.error || '❌ Failed to send WhatsApp notification');
    }
  } catch (err) {
    console.error(err);
    alert('Server error during WhatsApp notification');
  }
};


  return (
    <div className="mb-4">
      <div className="card shadow-sm rounded-4">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-start mb-2">
            <div>
              <h5 className="card-title mb-0">Customer: {order.customer_name}</h5>
              
<div className="mt-2 d-flex gap-2">
  <button
    className="btn btn-sm btn-outline-primary"
    onClick={() => sendWabaNotification(order.id, order.customer_id, 'created')}
  >
    📤 SEND MSG: New SO
  </button>

  <button
    className="btn btn-sm btn-outline-warning"
    onClick={() => sendWabaNotification(order.id, order.customer_id, 'updated')}
  >
    🔄 SEND MSG: Updated SO
  </button>
</div>
            </div>
            <div className="text-end">
              <div className="dropdown">
                <button
                  className="btn btn-sm btn-light"
                  type="button"
                  id={`dropdownMenuButton-${order.id}`}
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  &#x22EE; Actions &#x22EE;
                </button>
                <ul
                  className="dropdown-menu dropdown-menu-end"
                  aria-labelledby={`dropdownMenuButton-${order.id}`}
                >
                  {/* Heading */}
                  <li className="px-3">
                    <h6 className="dropdown-header">Edit Section</h6>
                  </li>

                  {/* Options */}
                  <li>
                    <button className="dropdown-item" onClick={() => setShowHeaderEdit(true)}>
                      Header
                    </button>
                  </li>
                  <li>
                    <button className="dropdown-item" onClick={() => setShowAttachmentEdit(true)}>
                      Attachments
                    </button>
                  </li>


                  {/* Separator */}
                  <li><hr className="dropdown-divider" /></li>

                  {/* Future Planning Area */}
                  <li className="px-3">
                    <h6 className="dropdown-header">SO Closing</h6>
                  </li>
                  <li>
                    <button className="dropdown-item" onClick={() => setShowItemEdit(true)}>
                      Close Sales Order
                    </button>
                  </li>
                </ul>

              </div>

            </div>
          </div>


          {/* Header Section */}
          {showHeaderEdit ? (
            <div className="mb-3">
              <div className="row g-2">
                <div className="col-md-4">
                  <label className="form-label">Customer PO No</label>
                  <input
                    className="form-control"
                    value={header.customer_po_no}
                    onChange={(e) => setHeader({ ...header, customer_po_no: e.target.value })}
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label">PO Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={header.po_date}
                    onChange={(e) => setHeader({ ...header, po_date: e.target.value })}
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label">Remark</label>
                  <input
                    className="form-control"
                    value={header.remark}
                    onChange={(e) => setHeader({ ...header, remark: e.target.value })}
                  />
                </div>
              </div>
              <button className="btn btn-sm btn-success mt-2 me-2" onClick={handleHeaderSave}>Save</button>
              <button className="btn btn-sm btn-secondary mt-2" onClick={() => setShowHeaderEdit(false)}>Cancel</button>
            </div>
          ) : (
            <>
              <p><strong>Customer PO No:</strong> {order.customer_po_no} <strong>PO Date:</strong> {order.po_date}</p>
              <p><strong>Remark:</strong> {order.remark || 'N/A'}</p>
            </>
          )}

          {/* Items Section */}
          {order.items?.length > 0 && (
            <>
              <h6 className="mt-3">Items:</h6>

              {/* Show table on md and up */}
              <div className="table-responsive d-none d-md-block">
                <table className="table table-sm table-bordered">
                  <thead className="table-light">
                    <tr>
                      <th>Material</th>
                      <th>Qty</th>
                      <th>Unit</th>
                      <th>Price</th>
                      <th>GST%</th>
                      <th>Total</th>
                      <th>GST Amt</th>
                      <th>Grand Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((item, i) => {
                      const total = item.qty * item.price;
                      const gstAmt = (total * item.gst) / 100;
                      const grandTotal = total + gstAmt;
                      return (
                        <tr key={i}>
                          <td>{item.material_name}</td>
                          <td>
                            <span
                              className="badge bg-secondary"
                              style={{ cursor: 'pointer' }}
                              onClick={() =>
                                setEditModal({ show: true, item, index: i, qty: item.qty, price: item.price })
                              }
                            >
                              {parseFloat(item.qty).toFixed(3)}
                            </span>
                          </td>
                          <td>{item.unit}</td>
                          <td>
                            <span
                              className="badge bg-secondary"
                              style={{ cursor: 'pointer' }}
                              onClick={() =>
                                setEditModal({ show: true, item, index: i, qty: item.qty, price: item.price })
                              }
                            >
                              {item.price}
                            </span>
                          </td>
                          <td>{item.gst}</td>
                          <td>{total.toFixed(2)}</td>
                          <td>{gstAmt.toFixed(2)}</td>
                          <td>{grandTotal.toFixed(2)}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* Show cards on small/mobile screens */}
              <div className="d-block d-md-none">
                {items.map((item, i) => {
                  const total = item.qty * item.price;
                  const gstAmt = (total * item.gst) / 100;
                  const grandTotal = total + gstAmt;

                  return (
                    <div className="card mb-2 shadow-sm border rounded-3" key={i}>
                      <div className="card-body p-2">
                        <h6 className="mb-2">{item.material_name}</h6>
                        <p className="mb-1">
                          <strong>Qty:</strong>{' '}
                          <span
                            className="badge bg-secondary"
                            style={{ cursor: 'pointer' }}
                            onClick={() =>
                              setEditModal({ show: true, item, index: i, qty: item.qty, price: item.price })
                            }
                          >
                            {item.qty}
                          </span>
                          {' '}<strong>{item.unit}</strong>
                        </p>
                        <p className="mb-1">
                          <strong>Price:</strong>{' '}
                          <span
                            className="badge bg-secondary"
                            style={{ cursor: 'pointer' }}
                            onClick={() =>
                              setEditModal({ show: true, item, index: i, qty: item.qty, price: item.price })
                            }
                          >
                            ₹{item.price}
                          </span>
                        </p>
                        <p className="mb-1"><strong>GST%:</strong> {item.gst}</p>
                        <p className="mb-1"><strong>Total:</strong> ₹{total.toFixed(2)}</p>
                        <p className="mb-1"><strong>GST Amt:</strong> ₹{gstAmt.toFixed(2)}</p>
                        <p className="mb-1"><strong>Grand Total:</strong> ₹{grandTotal.toFixed(2)}</p>
                      </div>
                    </div>
                  );
                })}
              </div>

              {showItemEdit && (
                <div className="mb-2">
                  <button className="btn btn-sm btn-success me-2" onClick={handleItemSave}>Save</button>
                  <button className="btn btn-sm btn-secondary" onClick={() => setShowItemEdit(false)}>Cancel</button>
                </div>
              )}
            </>
          )}



          {planningHistory.length > 0 && items.length > 0 && (
            <PlanningBalanceCard
              materialList={items}
              existingPlans={planningHistory}
            />
          )}
          {planningHistory.length > 0 && (
            <PlanningHistoryCard
              plans={planningHistory}
              onEdit={(plan) => {
                const planElement = document.getElementById(`plan-row-${plan.planning_id}`);
                if (planElement) planElement.scrollIntoView({ behavior: 'smooth' });
              }}
            />
          )}

          {/* Attachments Section */}
          <h6 className="mt-3">Attachments:</h6>
          {showAttachmentEdit ? (
            <>
              <input type="file" className="form-control" multiple onChange={handleAttachmentChange} />
              <ul className="list-group mt-2">
                {attachments.map((att, i) => (
                  <li key={i} className="list-group-item d-flex justify-content-between align-items-center">
                    <span>
                      📎 {att.original_name || att.name} <small>({att.file_type || att.type})</small>
                    </span>
                    <button className="btn btn-sm btn-danger" onClick={() => removeAttachment(i)}>Remove</button>
                  </li>
                ))}
              </ul>
              <button className="btn btn-sm btn-success mt-2 me-2" onClick={handleAttachmentSave}>Save</button>
              <button className="btn btn-sm btn-secondary mt-2" onClick={() => setShowAttachmentEdit(false)}>Cancel</button>
            </>
          ) : order.attachments?.length > 0 ? (
            <ul className="list-group list-group-flush">
              {order.attachments.map((att, i) => (
                <li key={i} className="list-group-item d-flex justify-content-between align-items-center">
                  <a
                    href={att.file_path}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-decoration-none"
                  >
                    📎 {att.original_name} <small>({att.file_type})</small>
                  </a>

                 
          {/* ⬇ Force download with original file name */}
          <a
            className="btn btn-sm btn-outline-primary"
            href={`${SALES_ORDER_ATTACHMENT_DOWNLOAD}?id=${att.id}`}
          >
            ⬇ Download
          </a>
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => handleDeleteExistingAttachment(att.id)}
                  >
                    Delete
                  </button>
                </li>
              ))}
            </ul>
          ) : (
            <div className="border rounded p-2 bg-light">
              <div className="text-danger">No attachments</div>
              <small className="text-muted d-block mt-1">
                Created by: {order.created_by} - {order.created_on}
              </small>
            </div>


          )}



        </div>
      </div>



      {/* Edit Modal */}
      {editModal.show && (
        <div className="modal show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog" role="document">
            <div className="modal-content border-0 shadow-lg">
              <div className="modal-header bg-primary text-white">
                <h5 className="modal-title">Edit Item: {editModal.item.material_name}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setEditModal({ show: false, item: null, index: null, qty: '', price: '' })}
                />
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">Qty</label>
                  <input
                    type="number"
                    className="form-control"
                    value={editModal.qty}
                    onChange={(e) => setEditModal({ ...editModal, qty: e.target.value })}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Price</label>
                  <input
                    type="number"
                    className="form-control"
                    value={editModal.price}
                    onChange={(e) => setEditModal({ ...editModal, price: e.target.value })}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-success" onClick={handleItemModalSave}>Save</button>
                <button
                  className="btn btn-secondary"
                  onClick={() => setEditModal({ show: false, item: null, index: null, qty: '', price: '' })}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

export default SalesOrderCard;
